import { Order } from '../../order';
import { ExternalEntityType } from '../entity';

export namespace SAP {
  export const isInboundDelivery = (order: Order) =>
    order.externalIdentifier?.type === ExternalEntityType.sap_inbound_delivery;
  export const isOutboundDelivery = (order: Order) =>
    order.externalIdentifier?.type === ExternalEntityType.sap_outbound_delivery;
}
